import React from 'react';
import { observer } from 'mobx-react';
import SmsMessages from './message-histories/SmsMessages';

const MessageHistories = () => {
  return <SmsMessages />;
};

export default observer(MessageHistories);
